import { render, staticRenderFns } from "./Revs.vue?vue&type=template&id=35b80c5b&scoped=true&"
import script from "./Revs.vue?vue&type=script&lang=js&"
export * from "./Revs.vue?vue&type=script&lang=js&"
import style0 from "./Revs.vue?vue&type=style&index=0&id=35b80c5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b80c5b",
  null
  
)

export default component.exports